import { DEFAULT_LATEST } from 'constants/dateLimits';
import { hasYesOrNo } from 'models/validate';

import { ValidateJSModel } from 'forms/shared/types';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import nameModelValidator from 'forms/shared/validators/models/name/name';
import { FinancialChildSupportItemModel } from '../types';
import { pvqChildSupportLocationValidator } from './pvqChildSupportLocationValidator';

export const pvqFinancialChildSupportItemValidator: ValidateJSModel<FinancialChildSupportItemModel> = {
  RecipientName: {
    presence: true,
    model: { validator: nameModelValidator },
  },
  AmountPastDue: {
    presence: true,
    model: { validator: currencyModelValidator },
  },
  ReasonPastDue: {
    presence: true,
    hasValue: true,
  },
  WhenPastDue: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;
    return {
      presence: true,
      date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
    };
  },
  CurrentlyPastDue: {
    hasValue: { validator: hasYesOrNo },
  },
  WhenBecameCurrent: (value, attributes, attributeName, options) => {
    const { applicantBirthdate } = options;
    if (attributes?.CurrentlyPastDue?.value === 'No') {
      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }

    return {};
  },
  ActionsTaken: (value, attributes) => {
    if (attributes?.CurrentlyPastDue?.value === 'Yes' && attributes?.ActionsTakenNone?.applicable !== false) {
      return {
        presence: true,
        hasValue: true,
      };
    }
    return {};
  },
  ActionsTakenReason: (value, attributes) => {
    if (attributes?.ActionsTakenNone?.applicable === false && attributes?.CurrentlyPastDue?.value === 'Yes') {
      return {
        presence: true,
        hasValue: true,
      };
    }

    return {};
  },
  CourtName: {
    presence: true,
    hasValue: true,
  },
  CourtLocation: {
    presence: true,
    location: {
      validator: pvqChildSupportLocationValidator,
      requireCounty: false,
    }
  },
  OrderNum: (value, attributes) => {
    if (attributes?.OrderNumIdk?.applicable !== false) {
      return {
        presence: true,
        hasValue: true
      };
    }
    return {};
  },
  AmountRequiredToPay: {
    presence: true,
    model: {
      validator: currencyModelValidator,
    },
  },
  AmountPastDueEstimated: {},
  WhenPastDueEstimated: {},
  OrderNumIdk: {},
};
